<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/H8DCde/tc-custom/9781480403789.jpg?1706066617405" alt="This image is the cover for the book Return of the Gypsy, The Daughters of England"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Return of the Gypsy, The Daughters of England
      </h1>
      <p class="bookDescription body article font2">
        <b>In Regency England, </b><b>a woman risks scandal, disgrace, even her own life for a forbidden passion in this “sure-to-please saga” (<i>Kirkus Reviews</i>).</b><br/>  From the moment the handsome, raffish stranger with the gold earring throws her a kiss, Jessica Frenshaw is enchanted. Rumored to be a half-Spanish wanderer who can predict the future, Romany Jake is unjustly put on trial for murder. After the verdict banishes him from England, Jessica despairs of ever seeing him again. But one fateful day, Jake Cadorson returns to reclaim what he has lost—including the woman who saved him from the gallows. From the ballrooms and lavish estates of Regency England through the bitter bloodshed of the Napoleonic Wars, <i>Return of the Gypsy</i> weaves a spellbinding tale of blackmail, murder, and illicit passion as a woman risks everything for the man she loves—a man who isn’t what he seems.  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Philippa Carr
      </h2>
      
      <p class="authorDescription body article">Philippa Carr (1906&ndash;1993) was one of the twentieth century&rsquo;s premier authors of historical fiction. She was born Eleanor Alice Burford, in London, England. Over the course of her career, she used eight pseudonyms, including Jean Plaidy and Victoria Holt&mdash;pen names that signaled a riveting combination of superlative suspense and the royal history of the Tudors and Plantagenets. Philippa Carr was Burford&rsquo;s last pseudonym, created in 1972. <i>The Miracle at St. Bruno&rsquo;s</i>, the first novel in Carr&rsquo;s acclaimed Daughters of England series, was followed by nineteen additional books. Burford died at sea on January 18, 1993. At the time of her death, there were over one hundred million copies of her books in print, and her popularity continues today.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0ba6d5dc